(function($) {

  'use strict';

  function PopupMc() {

    var self = this,
      $el = null,
      $mainMenu = null,

      options = {
        example: null,
      };

    /**
     * Generic resize
     */
    function onResize() {
     
    }


    /**
     * Public constructor
     * @param  {Object} opts Options
     */
    self.initialize = function(opts) {
      // extends options
      for (var i in opts) { options[i] = opts[i]; }

      // Caching
      $el = options.$el;
      $el = options.$el;

      $el.find('.js-language-switcher').change(function() {
        $('.mc_form').hide(0);
        $('.mc_form[data-lang="'+$(this).val()+'"]').show(0);
      });

      Cookies.set('mc_popup_' + mcPopupKey, 1, { expires: 60 });

      // *************
      window.cache.$window.on('resize', Utils.debounce(onResize, 3000));
      // Initial call on load
      onResize();

      // Get cookie value
      var cookieName = 'lg-hide-mc_popup_' + mcPopupKey;
      var cookieValue = window.getCookie( cookieName );

      console.log('cookieValue');
      console.log(cookieValue);

      if( !cookieValue ) {
        // hide popup panel
        $('[data-popup="js-mc-popup"]').show(0);

        // Close popup
        $('.js-close-popup').click(function() {
            var $popup = $(this).closest('.popup');
            $popup.removeClass('is-active');
            $popup.prev('.js-popup-overlay').removeClass('is-active');

            // set cookie for 3 days
            window.setCookie(cookieName, true, 3);

            // hide popup panel
            $('[data-popup="js-mc-popup"]').hide(0);
        });
      }
      else {
        $('[data-popup="js-mc-popup"]').hide(0);
        console.log('hide popup');
      }
      
    };

    self.initialize.apply(self, arguments);
    return self;
  }

  /* Namespace declaration */
  window.PopupMc = PopupMc;

}(jQuery));
